import Vue from 'vue'
import PositionBusIconRulesService from 'js/services/position-bus-icon-rules'

import template from './_bus-card.pug'

// @vue/component
export default Vue.extend({
  template: template(),

  props: {
    bus: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      positionBusIconRules: PositionBusIconRulesService
    }
  },

  computed: {
    lineBackgroundColor() {
      return `background-color: ${this.bus.subline_primary_color};`
    },

    lineColor() {
      return `color: ${this.bus.subline_primary_color};`
    }
  }
})
